import { render, staticRenderFns } from "./UsuarioEdit.vue?vue&type=template&id=2bd02f52&"
import script from "./UsuarioEdit.vue?vue&type=script&lang=js&"
export * from "./UsuarioEdit.vue?vue&type=script&lang=js&"
import style0 from "./UsuarioEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports